import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CoursesService } from 'src/app/services/courses.service';
import { QuizService } from 'src/app/services/quiz.service';
import { PDFDocument } from 'pdf-lib'
import { FileHelper } from 'src/app/helpers';
import { QuizQuestion } from 'src/app/models';

@Component({
  selector: 'app-module1-rw',
  templateUrl: './module1-rw.component.html',
  styleUrls: ['./module1-rw.component.css', '../rentwise.component.css']
})
export class Module1RwComponent implements OnInit {
  srcHandout: string = "../../../../../assets/sampleLetter.pdf";
  pdfHandoutFillable!: PDFDocument;

  module = 1;
  page = 1;
  flag = false;

  // Contains all questions for the module
  questions: QuizQuestion[] = [];

  constructor(private courseService: CoursesService, private router: Router, private quizService: QuizService) { }

  async ngOnInit(): Promise<void> {
    this.courseService.setCurrentCourseBy('RentWise');

    // Open the furthest page
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      this.page = this.courseService.currentCourse.furthestPageID + 1;
    }

    // Get the questions for this module and assign them to this.questions
    this.quizService.getModuleQuizzes("61772d100490445c29d1e730").toPromise().then((res: any) => {
      this.quizService.moduleQuizQuestions = res.docs;
      this.questions = this.quizService.moduleQuizQuestions;
    });

    const handoutFillablePdfBytes = await fetch("../../../../../assets/sampleLetter.pdf").then(res => res.arrayBuffer());
    this.pdfHandoutFillable = await PDFDocument.load(handoutFillablePdfBytes);

  }

  async downloadHandoutFillablePdf () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandoutFillable.save();
    FileHelper.saveByteArray('sampleLetter.pdf', pdfBytes, 'application/pdf');
  }

  // Update furthestModuleID
  updateProgress() {
    if (this.courseService.currentCourse.furthestModuleID < this.module) {
      this.courseService.updateFurthestModule().toPromise().then((res: any) => {
        console.log(res);
      });
    }
  }

  // Update furthestPageID
  updatePageProgress() {
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      if (this.courseService.currentCourse.furthestPageID < this.page) {
        this.courseService.updateFurthestPage(this.page).toPromise();
      }
    }
  }

 // Handle the quiz results, allow them to pass or not
  handleQuiz(valueEmitted: boolean){

    // Quiz passed
    if (valueEmitted) {
      this.updateProgress();
      this.router.navigate(['/module2-rw']);
    }

    // Review
    else {
      this.page = 1
    }
  }

  next(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.page += 1;
    window.scrollTo(0,0);
    this.updatePageProgress();
    return true;
  }

  back(){
    this.page -= 1;
    window.scrollTo(0,0);
    return true;
  }

  model = {
    question1: undefined,
    question2: undefined,
    question3: undefined,
    question4: undefined,
    question5: undefined,
    question6: undefined,
    question7: undefined,
    question8: undefined,

  };

  question1Picked = false;
  question2Picked = false;
  question3Picked = false;
  question4Picked = false;
  question5Picked = false;
  question6Picked = false;
  question7Picked = false;
  question8Picked = false;

  question1() {
    this.question1Picked = true;
    console.log(this.model.question1);
    console.log(typeof(this.model.question1));
  }
  question2() {
    this.question2Picked = true;
  }
  question3() {
    this.question3Picked = true;
  }
  question4() {
    this.question4Picked = true;
  }
  question5() {
    this.question5Picked = true;
  }
  question6() {
    this.question6Picked = true;
  }
  question7() {
    this.question7Picked = true;
  }
  question8() {
    this.question8Picked = true;
  }

  activityOneCorrect()
  {
    /*
      If a question is not picked, return false
    */
   if (!this.question1Picked || !this.question2Picked ||  !this.question3Picked || !this.question4Picked || !this.question5Picked
      || !this.question6Picked || !this.question7Picked || !this.question8Picked)
   {
      return false;
   }

   if (this.model.question1 == true  || this.model.question2 == true  || this.model.question3 == true  || this.model.question4 == true
      || this.model.question5 == true  || this.model.question6 == true  || this.model.question7 == true  || this.model.question8 == true )
      //If any are true, then return false
   {
    return false;
   }

   /*
    Default: return true
   */
   return true;
  }

  model7 = {
    model7_Q1: undefined,
    model7_Q2: undefined,
    model7_Q3: undefined,
    model7_Q4: undefined,
    model7_Q5: undefined,
    model7_Q6: undefined,
    model7_Q7: undefined,
    model7_Q8: undefined,
    model7_Q9: undefined,
    model7_Q10: undefined,
    model7_Q11: undefined,

  };

  model7_Q1 = false;
  model7_Q2 = false;
  model7_Q3 = false;
  model7_Q4 = false;
  model7_Q5 = false;
  model7_Q6 = false;
  model7_Q7 = false;
  model7_Q8 = false;
  model7_Q9 = false;
  model7_Q10 = false;
  model7_Q11 = false;

  m7_Q1() {
    this.model7_Q1 = true;
  }
  m7_Q2() {
    this.model7_Q2 = true;
  }
  m7_Q3() {
    this.model7_Q3 = true;
  }
  m7_Q4() {
    this.model7_Q4 = true;
  }
  m7_Q5() {
    this.model7_Q5 = true;
  }
  m7_Q6() {
    this.model7_Q6 = true;
  }
  m7_Q7() {
    this.model7_Q7 = true;
  }
  m7_Q8() {
    this.model7_Q8 = true;
  }
  m7_Q9() {
    this.model7_Q9 = true;
  }
  m7_Q10() {
    this.model7_Q10 = true;
  }
  m7_Q11() {
    this.model7_Q11 = true;
  }
  activityTwoCorrect()
  {
    /*
      If a question is not picked, return false
    */
   if (!this.model7_Q1 || !this.model7_Q2 ||  !this.model7_Q3 || !this.model7_Q4 || !this.model7_Q5
      || !this.model7_Q6 || !this.model7_Q7 || !this.model7_Q8 || !this.model7_Q9 || !this.model7_Q10 || !this.model7_Q11)
   {
      return false;
   }

   if (this.model7.model7_Q1 == true  || this.model7.model7_Q2 == true  || this.model7.model7_Q3 == true
    || this.model7.model7_Q4  || this.model7.model7_Q5  || this.model7.model7_Q6  || this.model7.model7_Q7
      || this.model7.model7_Q8  || this.model7.model7_Q9  || this.model7.model7_Q10  || this.model7.model7_Q11 )
      //If any are true, then return false
   {
    return false;
   }

   /*
    Default: return true
   */
   return true;
  }

  setFlag()
  {
    this.flag = true;
  }
  resetFlag()
  {
    this.flag = false;
  }

  all<T = unknown>(array: T[], value: T) {
    return array.every(v => v === value);
  }

  allOf(obj: Object, value = true) {
    return this.all(Object.values(obj), value);
  }
}
